module.exports = {
  install: function(Vue, options) {
    const component = {
      name: 'Confirm',
      props: ['config'],
      methods: {
        confirm(answer) {
          this.$emit('answer', answer);
        }
      },
      template: `
      <v-dialog v-model="config.visible" max-width="500">
        <v-toolbar dark color="secondary" dense>
          <v-icon>warning</v-icon>
          <v-toolbar-title>{{ $t('confirm.title') }}</v-toolbar-title>
        </v-toolbar>
        <v-card tile>
          <v-card-text>{{ config.question }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" flat @click="confirm(false)">{{ $t('confirm.negative') }}</v-btn>
            <v-btn color="accent" flat @click="confirm(true)">{{ $t('confirm.positive') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      `
    };
    Vue.component('confirm-dialog', component);
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/ConfirmDialog.js